import { Box } from "@mui/system";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import PrimaryButton from "../../components/custom/PrimaryButton";
import { Grid, Typography } from "@mui/material";
import TextField from "../../components/custom/TextField";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DistributorForm = ({
  edit = false,
  formikRef,
  onSubmit = () => {},
  data = {
    alias: "",
    description: "",
    distributorUrl: "",
    notifyUrl: "",
    publicKey: "",
    sharedSecret: "",
    linkExpiration: "",
    email: "",
  },
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const validationSchema = Yup.object().shape({
    alias: Yup.string().required(t("Please enter your name")),
    // distributorUrl: Yup.string().required(
    //   t("Please enter your distributor Url")
    // ),
    // notifyUrl: Yup.string().required(t("Please enter your notify Url")),
    // publicKey: Yup.string().required(t("Please enter your public Key")),
    // sharedSecret: Yup.string().required(t("Please enter your shared Secret")),
    // linkExpiration: Yup.number()
    //   .typeError(t("Must be number"))
    //   .positive()
    //   .required(t("Please enter your link Expiration")),
    email: Yup.string().email().required(t("Please enter your email")),
  });
  return (
    <Box sx={{ mb: 10 }}>
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={onSubmit}
        innerRef={formikRef}
        validationSchema={validationSchema}
      >
        {({ submitForm, values, dirty }) => (
          <Form>
            <TextField
              // disabled={edit}
              label={<Typography>{t("Name")}</Typography>}
              name="alias"
              type="alias"
              placeholder="ex.patakis"
            />
            <TextField
              label={<Typography>{t("Distributor Url")}</Typography>}
              name="distributorUrl"
              placeholder="ex.distributor.gr"
            />
            {/* <TextField
              label={<Typography>{t("Notify Url")}</Typography>}
              name="notifyUrl"
              placeholder="ex. www.google.gr"
            /> */}
            {/* <TextField
              disabled={edit}
              label={<Typography>{t("Public Key")}</Typography>}
              name="publicKey"
              placeholder="ex.---"
            /> */}
            <TextField
              disabled
              label={<Typography>{"Service Alias"}</Typography>}
              name="serviceAlias"
              placeholder="autogenerated"
            />
            <TextField
              disabled
              label={<Typography>{"Plugin Secret"}</Typography>}
              name="pluginSecret"
              placeholder="autogenerated"
            />
            {/* <TextField
              // disabled={edit}
              label={<Typography>{t("Link Expiration")}</Typography>}
              name="linkExpiration"
              placeholder="ex.---"
            /> */}
            <TextField
              label={<Typography>{t("email")}</Typography>}
              name="email"
              placeholder="ex.----"
            />
            <TextField
              label={<Typography>{t("Description")}</Typography>}
              name="description"
              placeholder="ex.description of the distributor"
              multiline
              rows={5}
            />
            <Grid container justifyContent="left">
              <PrimaryButton
                disabled={!dirty}
                onClick={submitForm}
                sx={{ my: { xs: 5, md: 10 }, mr: { xs: 1, md: 8 } }}
              >
                Save
              </PrimaryButton>
              <PrimaryButton
                onClick={() => navigate("/distributors")}
                sx={{ my: { xs: 5, md: 10 } }}
              >
                Cancel
              </PrimaryButton>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default DistributorForm;
